import moment from "moment";
import { useEffect, useReducer } from "react";
import { useSearchParams } from "react-router-dom";
import { useFormsContext } from "../context/formsContext";

export const useSearchParamsToReducer = () => {
	const [shouldSearch, refetch] = useReducer((x) => x + 1, 0);
	const [searchParams, setSearchParams] = useSearchParams();
	const {
		state: {
			dataToGetFormInstances: { firstTime },
		},
		actions: {
			setStartForms,
			setEndForms,
			setFormInstanceStatusCodeForms,
			setFirstTime,
		},
	} = useFormsContext();

	useEffect(() => {
		let shouldUpdate = false;

		if (searchParams.has("start")) {
			const start = searchParams.get("start");
			if (start === "") {
				searchParams.delete("start");
				shouldUpdate = true;
			}
			setStartForms(moment(decodeURIComponent(start!)).toDate());
		}

		if (searchParams.has("end")) {
			const end = searchParams.get("end");
			setEndForms(moment(decodeURIComponent(end!)).toDate());
		}

		if (searchParams.has("status")) {
			const status = searchParams.get("status");
			if (status === "") {
				searchParams.delete("status");
				shouldUpdate = true;
			}
			setFormInstanceStatusCodeForms(status);
		}

		if (shouldUpdate) {
			setSearchParams(searchParams, { replace: true });
		} else if (firstTime) {
			refetch();
			setFirstTime(false);
		}
	}, [searchParams]);

	return { shouldSearch };
};
